exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".animationModal .modal-dialog{display:flex;justify-content:center;align-items:center;height:40%;width:25%}.animationModal .modal-dialog .modal-content{height:100%;width:100%}.animationModal .modal-dialog .modal-content .studentAvatar{display:flex;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/games/animation_modal.scss
// module id = 1290
// module chunks = 0